<template>
  <div id="app">
    <!--Main contents block-->
    <div id="contents">
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #e5f1ea;
  margin: 0;
  padding: 0;
}
#app{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
}

#contents{
  position: relative;
  display: block;
}
</style>
